import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const EntrataWordIcon = createIcon({
  displayName: 'EntrataWordIcon',
  viewBox: '0 0 86 18',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.31329 3.90915C2.43584 3.90915 0 7.02294 0 10.631C0 14.6839 2.93295 17.3034 6.76069 17.3034C8.74913 17.3034 10.837 16.4632 12.0798 14.9804L10.0913 13.0034C9.4948 13.6459 8.30173 14.4862 6.86012 14.4862C5.02081 14.4862 3.52948 13.2505 3.38035 11.4218H12.3283C12.378 11.1252 12.4277 10.7793 12.4277 10.4333C12.4277 6.92409 9.89249 3.90915 6.31329 3.90915ZM3.52948 8.95053C3.67861 7.76432 4.87168 6.67697 6.31329 6.67697C7.7052 6.67697 8.74913 7.81375 8.89827 8.95053H3.52948ZM21.2763 3.90915C19.8347 3.90915 18.5919 4.4034 17.5977 5.19421V4.15628H14.2671V17.0069H17.7468V8.7034C18.2439 8.06087 19.437 7.12179 20.8786 7.12179C21.674 7.12179 22.3699 7.36892 22.8173 7.86317C23.3145 8.35743 23.6127 8.99996 23.6127 10.285V17.1057H27.0925V10.4827C27.0925 8.25858 26.5954 6.97352 25.7503 5.98501C24.7064 4.69995 23.0659 3.90915 21.2763 3.90915ZM57.3665 5.19421C56.3723 4.35398 55.0301 3.90915 53.5884 3.90915C50.059 3.90915 47.2254 6.82524 47.2254 10.631C47.2254 12.3609 47.8717 13.9919 48.8659 15.1287C50.0093 16.4632 51.8486 17.3034 53.7376 17.3034C55.0301 17.3034 56.2728 16.908 57.3168 16.0183V17.0563H60.6474V4.2057H57.3168V5.19421H57.3665ZM57.2671 8.7034V12.5586C56.6208 13.4977 55.4277 14.1402 54.1353 14.1402C52.1965 14.1402 50.7052 12.6574 50.7052 10.631C50.7052 8.75283 51.9977 7.12179 54.0358 7.12179C55.3283 7.07237 56.5214 7.66547 57.2671 8.7034ZM82.222 4.15628V5.19421C81.2277 4.35398 79.8856 3.90915 78.4439 3.90915C74.9145 3.90915 72.0809 6.82524 72.0809 10.631C72.0809 12.3609 72.7272 13.9919 73.7214 15.1287C74.8647 16.4632 76.704 17.3034 78.5931 17.3034C79.8856 17.3034 81.1283 16.908 82.1723 16.0183V17.0563H85.5029V4.2057H82.222V4.15628ZM82.0728 12.5586C81.4266 13.4977 80.2335 14.1402 78.941 14.1402C77.0023 14.1402 75.511 12.6574 75.511 10.631C75.511 8.75283 76.8035 7.12179 78.8416 7.12179C80.0844 7.12179 81.2775 7.7149 82.0231 8.7034V12.5586H82.0728ZM42.1549 5.49076V4.15628H38.8243V17.0069H42.304V8.95053C42.7514 8.15973 43.9445 7.07237 45.4358 7.07237C45.9329 7.07237 46.4301 7.12179 46.6786 7.22064L47.0763 7.3195V4.008C46.6786 3.95858 46.4301 3.90915 45.8832 3.90915C44.3919 3.90915 42.9503 4.50225 42.1549 5.49076ZM32.6601 0.597656H29.1803V13.7448H32.6601V7.12179H36.9353V4.15628H32.6601V0.597656ZM66.7618 0.597656H63.2821V13.7448H66.7618V7.12179H71.037V4.15628H66.7618V0.597656ZM35.941 17.0563V13.7448H32.6104V17.0563H35.941ZM70.0925 17.0563V13.7448H66.7618V17.0563H70.0925Z"
      fill="currentColor"
    />
  ),
});

export const PencilIcon = createIcon({
  displayName: 'PencilIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M18.29 1.88L18.12 1.71C17.5575 1.1482 16.795 0.832642 16 0.832642C15.205 0.832642 14.4425 1.1482 13.88 1.71L2.29 13.29C2.16209 13.42 2.07218 13.5826 2.03 13.76L1.03 17.76C0.98239 17.929 0.980137 18.1076 1.02347 18.2778C1.0668 18.448 1.15419 18.6038 1.27684 18.7295C1.39949 18.8552 1.55308 18.9464 1.72216 18.9939C1.89124 19.0413 2.06984 19.0435 2.24 19L6.24 18C6.41745 17.9578 6.57998 17.8679 6.71 17.74L18.29 6.15C18.8518 5.5875 19.1674 4.825 19.1674 4.03C19.1674 3.235 18.8518 2.4725 18.29 1.91V1.88ZM5.49 16.1L3.37 16.63L3.9 14.51L12.48 5.93L14.07 7.52L5.49 16.1ZM16.88 4.71L15.48 6.1L13.9 4.52L15.29 3.12C15.383 3.02627 15.4936 2.95188 15.6154 2.90111C15.7373 2.85034 15.868 2.8242 16 2.8242C16.132 2.8242 16.2627 2.85034 16.3846 2.90111C16.5064 2.95188 16.617 3.02627 16.71 3.12L16.88 3.29C16.9737 3.38296 17.0481 3.49357 17.0989 3.61542C17.1497 3.73728 17.1758 3.86799 17.1758 4C17.1758 4.13201 17.1497 4.26272 17.0989 4.38458C17.0481 4.50644 16.9737 4.61704 16.88 4.71Z"
      fill="currentColor"
    />
  ),
});

export const BellIcon = createIcon({
  displayName: 'BellIcon',
  viewBox: '0 0 25 24',
  path: (
    <path
      d="M20.2502 15.05C19.8802 14.35 19.4202 13.67 19.0702 12.99C18.7285 12.3798 18.5333 11.6986 18.5002 11V9.21C18.502 7.69616 17.963 6.23147 16.9802 5.08C16.0912 4.02513 14.8592 3.31704 13.5002 3.08V3C13.5002 2.73478 13.3948 2.48043 13.2073 2.29289C13.0198 2.10536 12.7654 2 12.5002 2C12.235 2 11.9806 2.10536 11.7931 2.29289C11.6056 2.48043 11.5002 2.73478 11.5002 3V3.09C10.1031 3.32615 8.83473 4.04908 7.91959 5.13077C7.00445 6.21247 6.50164 7.58312 6.5002 9V11C6.4686 11.702 6.27341 12.3868 5.9302 13C5.5802 13.68 5.1202 14.36 4.7502 15.06C4.54696 15.4325 4.46746 15.86 4.52318 16.2806C4.57891 16.7013 4.76698 17.0933 5.0602 17.4C5.24779 17.5914 5.47192 17.7431 5.71929 17.8462C5.96666 17.9493 6.23222 18.0016 6.5002 18H9.5002C9.5002 18.7956 9.81627 19.5587 10.3789 20.1213C10.9415 20.6839 11.7046 21 12.5002 21C13.2959 21 14.0589 20.6839 14.6215 20.1213C15.1841 19.5587 15.5002 18.7956 15.5002 18H18.5002C18.7689 18.0003 19.0349 17.9464 19.2823 17.8416C19.5297 17.7368 19.7535 17.5832 19.9402 17.39C20.2334 17.0833 20.4215 16.6913 20.4772 16.2706C20.5329 15.85 20.4534 15.4225 20.2502 15.05ZM12.5002 19C12.235 19 11.9806 18.8946 11.7931 18.7071C11.6056 18.5196 11.5002 18.2652 11.5002 18H13.5002C13.5002 18.2652 13.3948 18.5196 13.2073 18.7071C13.0198 18.8946 12.7654 19 12.5002 19ZM6.5002 16C6.8002 15.44 7.2802 14.73 7.7002 13.9C8.19604 13.0117 8.47045 12.0169 8.5002 11V9C8.5002 7.93913 8.92163 6.92172 9.67178 6.17157C10.4219 5.42143 11.4393 5 12.5002 5H12.9002C13.403 5.04772 13.8915 5.19418 14.3377 5.43098C14.7838 5.66779 15.1789 5.99028 15.5002 6.38C16.1564 7.17612 16.5106 8.17833 16.5002 9.21V11C16.5285 12.0127 16.7994 13.0038 17.2902 13.89C17.7102 14.72 18.1902 15.43 18.4902 15.99H6.5002V16Z"
      fill="currentColor"
    />
  ),
});

export const ZapIcon = createIcon({
  displayName: 'ZapIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
    </svg>
  ),
});

export const FolderPlusIcon = createIcon({
  displayName: 'FolderPlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 10v6" />
      <path d="M9 13h6" />
      <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
    </svg>
  ),
});

export const FolderIcon = createIcon({
  displayName: 'FolderIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
    </svg>
  ),
});

export const FolderOpenIcon = createIcon({
  displayName: 'FolderOpenIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" />
    </svg>
  ),
});

export const EllipsisVerticalIcon = createIcon({
  displayName: 'EllipsisVerticalIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="5" r="1" />
      <circle cx="12" cy="19" r="1" />
    </svg>
  ),
});

export const SettingsIcon = createIcon({
  displayName: 'SettingsIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 17H5" />
      <path d="M19 7h-9" />
      <circle cx="17" cy="17" r="3" />
      <circle cx="7" cy="7" r="3" />
    </svg>
  ),
});

export const HelpIcon = createIcon({
  displayName: 'HelpIcon',
  viewBox: '0 0 25 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 3C4.84315 3 3.5 4.34315 3.5 6V18C3.5 19.6569 4.84315 21 6.5 21H18.5C20.1569 21 21.5 19.6569 21.5 18V6C21.5 4.34315 20.1569 3 18.5 3H6.5ZM5.5 6C5.5 5.44772 5.94772 5 6.5 5H18.5C19.0523 5 19.5 5.44772 19.5 6V18C19.5 18.5523 19.0523 19 18.5 19H6.5C5.94772 19 5.5 18.5523 5.5 18V6ZM11.5312 9.30516C11.3271 9.46695 11.1875 9.69547 11.1875 10.0568C11.1875 10.6091 10.7398 11.0568 10.1875 11.0568C9.63522 11.0568 9.1875 10.6091 9.1875 10.0568C9.1875 9.05973 9.62607 8.26304 10.2891 7.73765C10.9268 7.23231 11.7326 7.00425 12.4945 7.00006C13.2562 6.99587 14.0666 7.2151 14.7092 7.72195C15.3785 8.24992 15.8125 9.05284 15.8125 10.0569C15.8125 11.4246 14.8618 12.0975 14.3293 12.4743C14.2977 12.4967 14.2677 12.5179 14.2394 12.5383C13.9404 12.7528 13.7698 12.8889 13.6553 13.0384C13.5684 13.1518 13.5 13.2916 13.5 13.55C13.5 14.1023 13.0523 14.55 12.5 14.55C11.9477 14.55 11.5 14.1023 11.5 13.55C11.5 12.84 11.7206 12.2753 12.0674 11.8224C12.3854 11.4071 12.7913 11.1158 13.0704 10.9155L13.0731 10.9135C13.7229 10.4471 13.8125 10.338 13.8125 10.0569C13.8125 9.67698 13.6684 9.44829 13.4705 9.29224C13.2459 9.11506 12.9 8.99786 12.5055 9.00003C12.1111 9.0022 11.7607 9.12331 11.5312 9.30516ZM13.5 16.3999C13.5 16.9522 13.0523 17.3999 12.5 17.3999C11.9477 17.3999 11.5 16.9522 11.5 16.3999C11.5 15.8476 11.9477 15.3999 12.5 15.3999C13.0523 15.3999 13.5 15.8476 13.5 16.3999Z"
      fill="currentColor"
    />
  ),
});

export const EyeIcon = createIcon({
  displayName: 'Eye',
  viewBox: '0 0 16 16',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0.666504C2.95 0.666504 0 6.17064 0 6.17064C0 6.17064 3.4 11.5756 8 11.5756C12.9 11.5756 16 6.17064 16 6.17064C16 6.17064 12.85 0.666504 8 0.666504ZM8.00003 10.3359C5.00003 10.3359 2.50003 7.36072 1.60003 6.17064C2.45003 5.07973 4.70003 1.90618 8.00003 1.90618C11.15 1.90618 13.55 5.12932 14.4 6.17064C13.55 7.41031 11.2 10.3359 8.00003 10.3359ZM7.99997 3.39377C7.54997 3.39377 7.09997 3.49294 6.69997 3.69129C7.24997 3.84005 7.59997 4.28633 7.59997 4.88137C7.59997 5.526 7.04997 6.12104 6.34997 6.12104C5.84997 6.12104 5.44997 5.82352 5.24997 5.42682C5.19997 5.67476 5.14997 5.92269 5.14997 6.17063C5.14997 7.70782 6.44997 8.94748 7.94997 8.94748C9.44997 8.94748 10.75 7.65823 10.75 6.17063C10.8 4.58385 9.54997 3.39377 7.99997 3.39377Z"
      fill="#1177D0"
    />
  ),
});

export const TextIcon = createIcon({
  displayName: 'Text',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.5C4.34315 2.5 3 3.84315 3 5.5V17.5C3 19.1569 4.34315 20.5 6 20.5H18C19.6569 20.5 21 19.1569 21 17.5V5.5C21 3.84315 19.6569 2.5 18 2.5H6ZM5 5.5C5 4.94772 5.44772 4.5 6 4.5H18C18.5523 4.5 19 4.94772 19 5.5V17.5C19 18.0523 18.5523 18.5 18 18.5H6C5.44772 18.5 5 18.0523 5 17.5V5.5ZM8.5 7C7.94772 7 7.5 7.44772 7.5 8V9.32703C7.5 9.87931 7.94772 10.327 8.5 10.327C9.05228 10.327 9.5 9.87931 9.5 9.32703V9H11V14H10.5C9.94772 14 9.5 14.4477 9.5 15C9.5 15.5523 9.94772 16 10.5 16H12H13.5C14.0523 16 14.5 15.5523 14.5 15C14.5 14.4477 14.0523 14 13.5 14H13V9H14.5V9.32703C14.5 9.87931 14.9477 10.327 15.5 10.327C16.0523 10.327 16.5 9.87931 16.5 9.32703V8C16.5 7.44772 16.0523 7 15.5 7H8.5Z"
        fill="#306688"
      />
    </svg>
  ),
});

export const AddInputIcon = createIcon({
  displayName: 'Add Input',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6C7.41322 6 8 6.44678 8 7.33333V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H8V16.6667L8 16.6678C7.99951 17.5536 7.41305 18 7 18C6.44772 18 6 18.4477 6 19C6 19.5523 6.44772 20 7 20C7.80336 20 8.4883 19.6713 9 19.1567C9.5117 19.6713 10.1966 20 11 20C11.5523 20 12 19.5523 12 19C12 18.4477 11.5523 18 11 18C10.587 18 10.0005 17.5536 10 16.6678V16.6667V13H11C11.5523 13 12 12.5523 12 12C12 11.4477 11.5523 11 11 11H10V7.33333C10 6.44678 10.5868 6 11 6C11.5523 6 12 5.55229 12 5C12 4.44772 11.5523 4 11 4C10.1966 4 9.51171 4.32868 9 4.84332C8.4883 4.32868 7.80336 4 7 4ZM4 10.5C4 9.94772 4.44772 9.5 5 9.5H5.25C5.80228 9.5 6.25 9.05228 6.25 8.5C6.25 7.94772 5.80228 7.5 5.25 7.5H5C3.34315 7.5 2 8.84315 2 10.5V13.5C2 15.1569 3.34315 16.5 5 16.5H5.5C6.05228 16.5 6.5 16.0523 6.5 15.5C6.5 14.9477 6.05228 14.5 5.5 14.5H5C4.44772 14.5 4 14.0523 4 13.5V10.5ZM12.5 7.5C11.9477 7.5 11.5 7.94772 11.5 8.5C11.5 9.05228 11.9477 9.5 12.5 9.5H19C19.5523 9.5 20 9.94772 20 10.5V13.5C20 14.0523 19.5523 14.5 19 14.5H12.5C11.9477 14.5 11.5 14.9477 11.5 15.5C11.5 16.0523 11.9477 16.5 12.5 16.5H19C20.6569 16.5 22 15.1569 22 13.5V10.5C22 8.84315 20.6569 7.5 19 7.5H12.5Z"
        fill="#4E4D4D"
      />
    </svg>
  ),
});

export const ViewIcon = createIcon({
  displayName: 'ViewIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.0625 11.9531C4.0625 11.7281 4.20027 11.2328 4.62155 10.5369C5.02232 9.87482 5.61653 9.13609 6.36329 8.4464C7.87017 7.05468 9.87752 5.96875 12.0156 5.96875C14.1537 5.96875 16.1611 7.05468 17.668 8.4464C18.4147 9.13609 19.0089 9.87482 19.4097 10.5369C19.831 11.2328 19.9688 11.7281 19.9688 11.9531C19.9688 12.1782 19.831 12.6734 19.4097 13.3694C19.0089 14.0314 18.4147 14.7702 17.668 15.4598C16.1611 16.8516 14.1537 17.9375 12.0156 17.9375C9.87752 17.9375 7.87017 16.8516 6.36329 15.4598C5.61653 14.7702 5.02232 14.0314 4.62155 13.3694C4.20027 12.6734 4.0625 12.1782 4.0625 11.9531ZM12.0156 3.96875C9.20905 3.96875 6.73985 5.37613 5.00633 6.97716C4.13289 7.78385 3.41595 8.66636 2.91061 9.50117C2.42579 10.3021 2.0625 11.1793 2.0625 11.9531C2.0625 12.7269 2.42579 13.6042 2.91061 14.4051C3.41595 15.2399 4.13289 16.1224 5.00633 16.9291C6.73985 18.5301 9.20905 19.9375 12.0156 19.9375C14.8222 19.9375 17.2914 18.5301 19.0249 16.9291C19.8984 16.1224 20.6153 15.2399 21.1206 14.4051C21.6055 13.6042 21.9688 12.7269 21.9688 11.9531C21.9688 11.1793 21.6055 10.3021 21.1206 9.50117C20.6153 8.66636 19.8984 7.78385 19.0249 6.97716C17.2914 5.37613 14.8222 3.96875 12.0156 3.96875ZM9.09375 11.9688C9.09375 10.3464 10.4089 9.03125 12.0312 9.03125C13.6536 9.03125 14.9688 10.3464 14.9688 11.9688C14.9688 13.5911 13.6536 14.9062 12.0312 14.9062C10.4089 14.9062 9.09375 13.5911 9.09375 11.9688ZM12.0312 7.03125C9.30434 7.03125 7.09375 9.24184 7.09375 11.9688C7.09375 14.6957 9.30434 16.9062 12.0312 16.9062C14.7582 16.9062 16.9688 14.6957 16.9688 11.9688C16.9688 9.24184 14.7582 7.03125 12.0312 7.03125Z"
      fill="currentColor"
    />
  ),
});

export const CopyIcon = createIcon({
  displayName: 'CopyIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.70711 2.87868C7.26972 2.31607 8.03278 2 8.82843 2H14C15.6569 2 17 3.34315 17 5V6H18C19.6569 6 21 7.34315 21 9V19C21 20.6569 19.6569 22 18 22H10C8.34315 22 7 20.6569 7 19V18H6C4.34315 18 3 16.6569 3 15V7.82843C3 7.03278 3.31607 6.26972 3.87868 5.70711L6.70711 2.87868ZM12 7C12 6.44772 12.4477 6 13 6H15V5C15 4.44772 14.5523 4 14 4H10L10 6.5C10 7.88071 8.88071 9 7.5 9L5 9L5 15C5 15.5523 5.44772 16 6 16H7V14.5C7 13.9477 7.44772 13.5 8 13.5C8.55228 13.5 9 13.9477 9 14.5V17V19C9 19.5523 9.44772 20 10 20H18C18.5523 20 19 19.5523 19 19V9C19 8.44772 18.5523 8 18 8H16H13C12.4477 8 12 7.55228 12 7ZM5.41421 7L7.5 7C7.77614 7 8 6.77614 8 6.5L8 4.41421L5.41421 7ZM12.75 14.5H12.8358L10.0429 11.7071C9.65237 11.3166 9.65237 10.6834 10.0429 10.2929C10.4334 9.90237 11.0666 9.90237 11.4571 10.2929L14.25 13.0858V13C14.25 12.4477 14.6977 12 15.25 12C15.8023 12 16.25 12.4477 16.25 13L16.25 15.4C16.25 16.0075 15.7575 16.5 15.15 16.5L12.75 16.5C12.1977 16.5 11.75 16.0523 11.75 15.5C11.75 14.9477 12.1977 14.5 12.75 14.5Z"
      fill="currentColor"
    />
  ),
});

export const CirclePlusIcon = createIcon({
  displayName: 'CirclePlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM16 12C16 12.2652 15.8946 12.5196 15.7071 12.7071C15.5196 12.8946 15.2652 13 15 13H13V15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071C11.1054 15.5196 11 15.2652 11 15V13H9C8.73479 13 8.48043 12.8946 8.2929 12.7071C8.10536 12.5196 8 12.2652 8 12C8 11.7348 8.10536 11.4804 8.2929 11.2929C8.48043 11.1054 8.73479 11 9 11H11V9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9V11H15C15.2652 11 15.5196 11.1054 15.7071 11.2929C15.8946 11.4804 16 11.7348 16 12Z"
      fill="currentColor"
    />
  ),
});

export const SquarePlusIcon = createIcon({
  displayName: 'SquarePlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <path d="M8 12h8" />
      <path d="M12 8v8" />
    </svg>
  ),
});

export const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </svg>
  ),
});

export const RemoveIcon = createIcon({
  displayName: 'Remove',
  viewBox: '0 0 16 16',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6516 2.33229C10.5456 -0.77743 5.4356 -0.77743 2.32954 2.33229C-0.776515 5.44201 -0.776515 10.558 2.32954 13.6677C5.4356 16.7774 10.5456 16.7774 13.6516 13.6677C16.7577 10.558 16.8078 5.44201 13.6516 2.33229ZM3.3816 12.6144C0.826613 10.0564 0.826613 5.94357 3.3816 3.38558C5.93658 0.827586 10.0446 0.827586 12.5996 3.38558C15.1546 5.94357 15.1546 10.0564 12.5996 12.6144C10.0446 15.1724 5.93658 15.1724 3.3816 12.6144ZM11.5475 5.49216L10.4955 4.43887L7.99059 6.94671L5.4857 4.43887L4.43365 5.49216L6.93854 8L4.43365 10.5078L5.4857 11.5611L7.99059 9.05329L10.4955 11.5611L11.5475 10.5078L9.04264 8L11.5475 5.49216Z"
      fill="#E42127"
    />
  ),
});

export const TrashIcon = createIcon({
  displayName: 'Trash',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M13 17V11C13 10.7348 13.1054 10.4804 13.2929 10.2929C13.4804 10.1054 13.7348 10 14 10C14.2652 10 14.5196 10.1054 14.7071 10.2929C14.8946 10.4804 15 10.7348 15 11V17C15 17.2652 14.8946 17.5196 14.7071 17.7071C14.5196 17.8946 14.2652 18 14 18C13.7348 18 13.4804 17.8946 13.2929 17.7071C13.1054 17.5196 13 17.2652 13 17ZM10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM21 7C21 7.26522 20.8946 7.51957 20.7071 7.70711C20.5196 7.89464 20.2652 8 20 8H19V18.94C19 19.7356 18.6839 20.4987 18.1213 21.0613C17.5587 21.6239 16.7956 21.94 16 21.94H8C7.20435 21.94 6.44129 21.6239 5.87868 21.0613C5.31607 20.4987 5 19.7356 5 18.94V8H4C3.73478 8 3.48043 7.89464 3.29289 7.70711C3.10536 7.51957 3 7.26522 3 7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H8V5C8 4.20435 8.31607 3.44129 8.87868 2.87868C9.44129 2.31607 10.2044 2 11 2H13C13.7956 2 14.5587 2.31607 15.1213 2.87868C15.6839 3.44129 16 4.20435 16 5V6H20C20.2652 6 20.5196 6.10536 20.7071 6.29289C20.8946 6.48043 21 6.73478 21 7ZM10 6H14V5C14 4.73478 13.8946 4.48043 13.7071 4.29289C13.5196 4.10536 13.2652 4 13 4H11C10.7348 4 10.4804 4.10536 10.2929 4.29289C10.1054 4.48043 10 4.73478 10 5V6ZM17 8H7V18.94C7 19.2052 7.10536 19.4596 7.29289 19.6471C7.48043 19.8346 7.73478 19.94 8 19.94H16C16.2652 19.94 16.5196 19.8346 16.7071 19.6471C16.8946 19.4596 17 19.2052 17 18.94V8Z"
      fill="currentColor"
    />
  ),
});

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 16 16',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.345 13.4268C13.7032 13.0922 13.7133 12.5275 13.3672 12.1803L10.4562 9.26019C11.1562 8.29467 11.5938 7.10972 11.5938 5.83699C11.5938 2.58934 8.96875 0 5.775 0C2.58125 0 0 2.58934 0 5.7931C0 8.99686 2.58125 11.5862 5.775 11.5862C7.04375 11.5862 8.225 11.1473 9.1875 10.4451L12.1384 13.4053C12.4689 13.7368 13.0028 13.7464 13.345 13.4268ZM1.3125 5.7931C1.3125 3.33542 3.325 1.31661 5.775 1.31661C8.225 1.31661 10.2375 3.33542 10.2375 5.7931C10.2375 8.25078 8.225 10.2696 5.775 10.2696C3.325 10.3135 1.3125 8.29467 1.3125 5.7931Z"
      fill="#4E4D4D"
    />
  ),
});

export const InfoCircleIcon = createIcon({
  displayName: 'InfoCircle',
  viewBox: '0 0 16 16',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.5C4.4 14.5 1.5 11.6 1.5 8C1.5 4.4 4.4 1.5 8 1.5C11.6 1.5 14.5 4.4 14.5 8C14.5 11.6 11.6 14.5 8 14.5ZM8.7 6.7C8.05 6.7 7.25 7 6.55 7.8C6.5 7.9 6.6 8.05 6.75 8.1C6.95 7.9 7.4 7.5 7.5 7.7C7.7 8 6.1 10.5 6.1 11.55C6.1 11.85 6.35 12.05 6.7 12.05C7.7 12.05 8.4 11.6 8.9 10.95C8.95 10.8 8.8 10.65 8.65 10.65C8.35 10.95 8.05 11.3 7.9 11.1C7.65 10.8 9.2 8.35 9.3 7.3C9.3 6.95 9 6.7 8.7 6.7ZM9.2 4C8.6 4 8.2 4.5 8.2 5.05C8.2 5.45 8.5 5.75 8.95 5.75C9.55 5.75 9.9 5.3 9.9 4.75C9.85 4.25 9.6 4 9.2 4Z"
      fill="#0E61AA"
    />
  ),
});

export const TypeIcon = createIcon({
  displayName: 'TypeIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 4v16" />
      <path d="M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2" />
      <path d="M9 20h6" />
    </svg>
  ),
});

export const QIcon = createIcon({
  displayName: 'QIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 12C19 16.4183 15.9183 20 11.5 20C7.08172 20 4 16.4183 4 12C4 7.58172 7.08172 4 11.5 4C15.9183 4 19 7.58172 19 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M16.3895 19C16.3895 19 16.7468 19.831 17.4937 20.2135C18.2405 20.5961 19.3769 20.5302 19.3769 20.5302"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const SyncIcon = createIcon({
  displayName: 'Sync',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.88009 8.05993C7.11009 8.93993 6.62009 10.0099 6.44009 11.1599L7.44009 10.3199C7.86009 9.95993 8.49009 10.0199 8.85009 10.4399C9.21009 10.8599 9.15009 11.4899 8.73009 11.8499L6.84009 13.4399C6.10009 14.0599 5.02009 14.0599 4.27009 13.4399L2.36009 11.8599C1.94009 11.5099 1.88009 10.8799 2.23009 10.4499C2.58009 10.0299 3.21009 9.96993 3.64009 10.3199L4.48009 11.0199C4.69009 9.44993 5.35009 7.97993 6.39009 6.77993C7.43009 5.58993 8.80009 4.71993 10.3301 4.29993C11.8601 3.86993 13.4801 3.90993 14.9901 4.39993C16.5001 4.88993 17.8401 5.80993 18.8301 7.04993C18.9101 7.14993 18.9801 7.26993 19.0101 7.39993C19.0501 7.52993 19.0601 7.65993 19.0501 7.78993C19.0401 7.91993 19.0001 8.04993 18.9301 8.15993C18.8701 8.27993 18.7801 8.37993 18.6801 8.45993C18.5801 8.53993 18.4601 8.59993 18.3301 8.63993C18.2001 8.67993 18.0701 8.68993 17.9401 8.66993C17.8101 8.65993 17.6801 8.60993 17.5701 8.54993C17.4501 8.48993 17.3501 8.39993 17.2701 8.29993C16.5301 7.35993 15.5201 6.65993 14.3801 6.27993C13.2401 5.90993 12.0101 5.87993 10.8601 6.18993C9.70009 6.50993 8.66009 7.15993 7.88009 8.05993ZM16.0601 16.1199C16.8301 15.2399 17.3201 14.1699 17.5001 13.0199L16.5001 13.8599C16.0801 14.2199 15.4501 14.1599 15.0901 13.7399C14.7301 13.3199 14.7901 12.6899 15.2101 12.3299L17.1001 10.7399C17.8401 10.1199 18.9201 10.1199 19.6701 10.7399L21.5701 12.3299C21.9901 12.6799 22.0501 13.3099 21.7001 13.7399C21.3501 14.1599 20.7201 14.2199 20.2901 13.8699L19.4501 13.1699C19.2401 14.7399 18.5801 16.2099 17.5401 17.4099C16.5001 18.6099 15.1301 19.4799 13.6001 19.8999C12.0701 20.3299 10.4501 20.2899 8.94009 19.7999C7.43009 19.3099 6.09009 18.3899 5.10009 17.1499C5.02009 17.0499 4.95009 16.9299 4.92009 16.7999C4.88009 16.6699 4.87009 16.5399 4.88009 16.4099C4.89009 16.2799 4.93009 16.1499 5.00009 16.0399C5.06009 15.9199 5.15009 15.8199 5.25009 15.7399C5.35009 15.6599 5.47009 15.5999 5.60009 15.5599C5.73009 15.5199 5.86009 15.5099 5.99009 15.5299C6.12009 15.5399 6.25009 15.5899 6.36009 15.6499C6.48009 15.7099 6.58009 15.7999 6.66009 15.8999C7.40009 16.8399 8.41009 17.5399 9.55009 17.9199C10.6901 18.2899 11.9201 18.3199 13.0701 18.0099C14.2301 17.6899 15.2701 17.0399 16.0501 16.1399L16.0601 16.1199Z"
        fill="#3878A0"
      />
    </svg>
  ),
});

export const PageIcon = createIcon({
  displayName: 'Page',
  viewBox: '0 0 12 14',
  path: (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 1.66659C1.63181 1.66659 1.33333 1.96506 1.33333 2.33325V11.6666C1.33333 12.0348 1.63181 12.3333 2 12.3333H10C10.3682 12.3333 10.6667 12.0348 10.6667 11.6666L10.6667 4.99992H9C8.07952 4.99992 7.33333 4.25373 7.33333 3.33325V1.66659L2 1.66659ZM8.66667 1.94273V3.33325C8.66667 3.51735 8.8159 3.66659 9 3.66659H10.3905L8.66667 1.94273ZM0 2.33325C0 1.22868 0.895431 0.333252 2 0.333252H8.11438C8.64482 0.333252 9.15352 0.543965 9.52859 0.919038L11.4142 2.80466C11.7893 3.17973 12 3.68844 12 4.21887V11.6666C12 12.7712 11.1046 13.6666 10 13.6666H2C0.895431 13.6666 0 12.7712 0 11.6666V2.33325ZM2.66667 4.33325C2.66667 3.96506 2.96514 3.66658 3.33333 3.66658H5.33333C5.70152 3.66658 6 3.96506 6 4.33325C6 4.70144 5.70152 4.99992 5.33333 4.99992H3.33333C2.96514 4.99992 2.66667 4.70144 2.66667 4.33325ZM2.66667 9.66658C2.66667 9.2984 2.96514 8.99992 3.33333 8.99992H8.66667C9.03486 8.99992 9.33333 9.2984 9.33333 9.66658C9.33333 10.0348 9.03486 10.3333 8.66667 10.3333H3.33333C2.96514 10.3333 2.66667 10.0348 2.66667 9.66658ZM3.33333 6.33325C2.96514 6.33325 2.66667 6.63173 2.66667 6.99992C2.66667 7.36811 2.96514 7.66659 3.33333 7.66659H8.66667C9.03486 7.66659 9.33333 7.36811 9.33333 6.99992C9.33333 6.63173 9.03486 6.33325 8.66667 6.33325H3.33333Z"
        fill="#4E4D4D"
      />
    </svg>
  ),
});

export const DotIcon = createIcon({
  displayName: 'Dot',
  viewBox: '0 0 4 4',
  path: (
    <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2" r="2" fill="#3878A0" />
    </svg>
  ),
});

export const UpDownArrowIcon = createIcon({
  displayName: 'UpDownArrow',
  viewBox: '0 0 16 17',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33535 7.16699C5.51274 7.16699 5.68286 7.09658 5.8083 6.97125L7.99984 4.77487L10.1914 6.97125C10.2535 7.03331 10.3272 7.08254 10.4084 7.11612C10.4895 7.14971 10.5765 7.16699 10.6643 7.16699C10.7522 7.16699 10.8391 7.14971 10.9203 7.11612C11.0014 7.08254 11.0752 7.03331 11.1373 6.97125C11.1994 6.9092 11.2486 6.83553 11.2823 6.75444C11.3159 6.67336 11.3332 6.58646 11.3332 6.4987C11.3332 6.41094 11.3159 6.32404 11.2823 6.24295C11.2486 6.16187 11.1994 6.0882 11.1373 6.02614L8.47278 3.36387C8.41086 3.30148 8.33718 3.25197 8.25601 3.21818C8.17484 3.18439 8.08777 3.16699 7.99984 3.16699C7.9119 3.16699 7.82484 3.18439 7.74366 3.21818C7.66249 3.25197 7.58882 3.30148 7.52689 3.36387L4.86241 6.02614C4.73697 6.15147 4.6665 6.32146 4.6665 6.4987C4.6665 6.67594 4.73697 6.84592 4.86241 6.97125C4.98784 7.09658 5.15796 7.16699 5.33535 7.16699ZM10.6643 9.83366C10.4869 9.83366 10.3168 9.90407 10.1914 10.0294L7.99984 12.2258L5.8083 10.0294C5.74619 9.96734 5.67246 9.91811 5.59131 9.88453C5.51016 9.85094 5.42319 9.83366 5.33535 9.83366C5.24752 9.83366 5.16054 9.85094 5.07939 9.88453C4.99825 9.91811 4.92451 9.96734 4.86241 10.0294C4.8003 10.0915 4.75103 10.1651 4.71742 10.2462C4.6838 10.3273 4.6665 10.4142 4.6665 10.502C4.6665 10.5897 4.6838 10.6766 4.71742 10.7577C4.75103 10.8388 4.8003 10.9124 4.86241 10.9745L7.52689 13.6368C7.58882 13.6992 7.66249 13.7487 7.74366 13.7825C7.82484 13.8163 7.9119 13.8337 7.99984 13.8337C8.08777 13.8337 8.17484 13.8163 8.25601 13.7825C8.33719 13.7487 8.41086 13.6992 8.47278 13.6368L11.1373 10.9745C11.2627 10.8492 11.3332 10.6792 11.3332 10.502C11.3332 10.3247 11.2627 10.1547 11.1373 10.0294C11.0118 9.90407 10.8417 9.83366 10.6643 9.83366Z"
        fill="#777676"
      />
    </svg>
  ),
});

export const DraggableIcon = createIcon({
  displayName: 'Draggable',
  viewBox: '0 0 15 15',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z"
      fill="currentColor"
    />
  ),
});

export const StopSignIcon = createIcon({
  displayName: 'Stop Sign',
  viewBox: '0 0 22 22',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4891 0H6.44237L0 6.4625V15.6062L6.44237 22H15.5576L22 15.5375V6.4625L15.4891 0ZM19.8754 14.7125L14.6667 19.9375H7.2648L2.05607 14.7125V7.2875L7.2648 2.0625H14.6667L19.8754 7.2875V14.7125ZM5.48287 12.375H16.4486V9.625H5.48287V12.375Z"
      fill="#C0232C"
    />
  ),
});

export const SuccessIcon = createIcon({
  displayName: 'Success',
  viewBox: '0 0 25 24',
  path: (
    <path
      d="M16.14 9.36C16.3086 9.53037 16.4031 9.76035 16.4031 10C16.4031 10.2397 16.3086 10.4696 16.14 10.64L12.14 14.64C11.9696 14.8085 11.7397 14.9031 11.5 14.9031C11.2604 14.9031 11.0304 14.8085 10.86 14.64L8.86 12.64C8.71825 12.4653 8.64626 12.2442 8.65794 12.0195C8.66962 11.7948 8.76414 11.5823 8.92325 11.4232C9.08235 11.2641 9.29477 11.1696 9.51948 11.1579C9.74419 11.1463 9.96526 11.2182 10.14 11.36L11.5 12.73L14.86 9.36C15.0304 9.19145 15.2604 9.09692 15.5 9.09692C15.7397 9.09692 15.9696 9.19145 16.14 9.36ZM22.5 12C22.5 13.9778 21.9135 15.9112 20.8147 17.5557C19.7159 19.2002 18.1541 20.4819 16.3268 21.2388C14.4996 21.9957 12.4889 22.1937 10.5491 21.8079C8.60929 21.422 6.82746 20.4696 5.42894 19.0711C4.03041 17.6725 3.078 15.8907 2.69215 13.9509C2.3063 12.0111 2.50433 10.0004 3.26121 8.17317C4.01809 6.3459 5.29981 4.78412 6.9443 3.6853C8.58879 2.58649 10.5222 2 12.5 2C13.8132 2 15.1136 2.25866 16.3268 2.7612C17.5401 3.26375 18.6425 4.00035 19.5711 4.92893C20.4997 5.85752 21.2363 6.95991 21.7388 8.17317C22.2413 9.38642 22.5 10.6868 22.5 12ZM20.5 12C20.5 10.4177 20.0308 8.87103 19.1518 7.55544C18.2727 6.23984 17.0233 5.21447 15.5615 4.60896C14.0997 4.00346 12.4911 3.84504 10.9393 4.15372C9.38743 4.4624 7.96197 5.22433 6.84315 6.34315C5.72433 7.46197 4.9624 8.88743 4.65372 10.4393C4.34504 11.9911 4.50347 13.5997 5.10897 15.0615C5.71447 16.5233 6.73985 17.7727 8.05544 18.6518C9.37104 19.5308 10.9178 20 12.5 20C14.6217 20 16.6566 19.1571 18.1569 17.6569C19.6572 16.1566 20.5 14.1217 20.5 12Z"
      fill="#FDFDFD"
    />
  ),
});

export const ErrorIcon = createIcon({
  displayName: 'Error',
  viewBox: '0 0 1000 1000',
  path: (
    <path
      d="M512 928c229.44 0 416-186.56 416-416S741.44 96 512 96 96 282.56 96 512s186.56 416 416 416z m0-896c264.672 0 480 215.36 480 480s-215.328 480-480 480C247.36 992 32 776.64 32 512S247.36 32 512 32z m214.72 265.28c12.512 12.48 12.512 32.96 0 45.44L557.44 512l169.28 169.28c6.08 6.4 9.28 14.4 9.28 22.72 0 8.32-3.2 16.32-9.28 22.72A32.64 32.64 0 0 1 704 736c-8.32 0-16.32-3.2-22.72-9.28L512 557.44l-169.28 169.28A32.64 32.64 0 0 1 320 736c-8.32 0-16.32-3.2-22.72-9.28-12.48-12.48-12.48-32.96 0-45.44L466.56 512l-169.28-169.28c-6.048-6.4-9.28-14.4-9.28-22.72 0-8.32 3.232-16.32 9.28-22.72 12.512-12.48 32.96-12.48 45.44 0L512 466.56l169.28-169.28c12.512-12.48 32.96-12.48 45.44 0z"
      fill="#FDFDFD"
    />
  ),
});

export const BlankTemplateIcon = createIcon({
  displayName: 'BlankTemplateIcon',
  viewBox: '0 0 80 80',
  path: (
    <g>
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#75A97D"
      />
      <path
        d="M23 19.52C23 18.7793 23.2942 18.069 23.818 17.5453C24.3417 17.0215 25.0521 16.7273 25.7927 16.7273H46.2727L57.9091 26.5018V60.48C57.9091 60.8468 57.8369 61.2099 57.6965 61.5488C57.5562 61.8876 57.3504 62.1954 57.0911 62.4548C56.8318 62.7141 56.5239 62.9198 56.1851 63.0602C55.8463 63.2005 55.4831 63.2728 55.1164 63.2728H25.7927C25.0521 63.2728 24.3417 62.9785 23.818 62.4548C23.2942 61.931 23 61.2207 23 60.48V19.52Z"
        fill="#FDFDFD"
      />
      <path
        d="M46.2725 16.7273V23.7091C46.2725 24.4498 46.5667 25.1601 47.0904 25.6839C47.6142 26.2076 48.3245 26.5018 49.0652 26.5018H57.9088L46.2725 16.7273Z"
        fill="#E8E8E8"
      />
      <path
        d="M34.9513 50.1557C34.92 50.1919 34.8767 50.2156 34.8293 50.2227C29.2533 51.06 26.0507 54.2693 25.22 59.8507C25.2067 59.936 25.1333 60 25.0467 60H24.9747C24.9268 59.9999 24.8806 59.9826 24.8443 59.9513C24.8081 59.92 24.7844 59.8767 24.7773 59.8293C23.9413 54.2613 20.74 51.0587 15.1707 50.2227C15.1233 50.2156 15.08 50.1919 15.0487 50.1557C15.0174 50.1194 15.0001 50.0732 15 50.0253V49.9747C15.0001 49.9268 15.0174 49.8806 15.0487 49.8443C15.08 49.8081 15.1233 49.7844 15.1707 49.7773C20.74 48.9413 23.9413 45.7387 24.7773 40.1707C24.7844 40.1233 24.8081 40.08 24.8443 40.0487C24.8806 40.0174 24.9268 40.0001 24.9747 40H25.0253C25.0732 40.0001 25.1194 40.0174 25.1557 40.0487C25.1919 40.08 25.2156 40.1233 25.2227 40.1707C26.0587 45.7387 29.26 48.9413 34.8293 49.7773C34.8767 49.7844 34.92 49.8081 34.9513 49.8443C34.9826 49.8806 34.9999 49.9268 35 49.9747V50.0253C34.9999 50.0732 34.9826 50.1194 34.9513 50.1557Z"
        fill="#E7AF55"
      />
      <path
        d="M62.8895 39.6446C62.9202 39.64 62.9483 39.6245 62.9685 39.6009C62.9888 39.5774 63 39.5473 63 39.5162V39.4838C63 39.4527 62.9888 39.4226 62.9685 39.3991C62.9483 39.3755 62.9202 39.36 62.8895 39.3554C59.269 38.8126 57.189 36.731 56.6446 33.1105C56.64 33.0798 56.6245 33.0517 56.6009 33.0315C56.5774 33.0112 56.5473 33 56.5162 33H56.4838C56.4527 33 56.4226 33.0112 56.3991 33.0315C56.3755 33.0517 56.36 33.0798 56.3554 33.1105C55.8126 36.7294 53.731 38.811 50.1105 39.3554C50.0798 39.36 50.0517 39.3755 50.0315 39.3991C50.0112 39.4226 50 39.4527 50 39.4838V39.5162C50 39.5812 50.0471 39.6349 50.1105 39.6446C53.731 40.1874 55.811 42.269 56.3554 45.8895C56.36 45.9202 56.3755 45.9483 56.3991 45.9685C56.4226 45.9888 56.4527 46 56.4838 46H56.5309C56.5582 45.9999 56.5845 45.99 56.6051 45.9721C56.6256 45.9542 56.6391 45.9295 56.643 45.9025C57.1825 42.2755 59.2641 40.189 62.8895 39.6446Z"
        fill="#E7AF55"
      />
      <path
        d="M41.915 24.1113C41.9386 24.1077 41.9602 24.0957 41.9758 24.0776C41.9914 24.0595 42 24.0364 42 24.0125V23.9875C42 23.9636 41.9914 23.9405 41.9758 23.9224C41.9602 23.9043 41.9386 23.8923 41.915 23.8887C39.13 23.4712 37.53 21.87 37.1113 19.085C37.1077 19.0614 37.0957 19.0398 37.0776 19.0242C37.0595 19.0086 37.0364 19 37.0125 19H36.9875C36.9636 19 36.9405 19.0086 36.9224 19.0242C36.9043 19.0398 36.8923 19.0614 36.8887 19.085C36.4712 21.8688 34.87 23.47 32.085 23.8887C32.0614 23.8923 32.0398 23.9043 32.0242 23.9224C32.0086 23.9405 32 23.9636 32 23.9875V24.0125C32 24.0625 32.0363 24.1038 32.085 24.1113C34.87 24.5288 36.47 26.13 36.8887 28.915C36.8923 28.9386 36.9043 28.9602 36.9224 28.9758C36.9405 28.9914 36.9636 29 36.9875 29H37.0238C37.0447 28.9999 37.065 28.9923 37.0808 28.9785C37.0966 28.9648 37.107 28.9458 37.11 28.925C37.525 26.135 39.1262 24.53 41.915 24.1113Z"
        fill="#E7AF55"
      />
    </g>
  ),
});

export const StudentTemplateIcon = createIcon({
  displayName: 'StudentTemplateIcon',
  viewBox: '0 0 80 80',
  path: (
    <g>
      <path
        fill="#EAA885"
        d="M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40Z"
      />
      <path
        fill="#777676"
        stroke="#777676"
        d="M56.172 47.533c0 .718-.37 1.456-1.152 2.18-.783.727-1.943 1.404-3.419 1.982-2.948 1.156-7.055 1.883-11.617 1.883-4.562 0-8.67-.727-11.618-1.883-1.476-.578-2.636-1.255-3.419-1.981-.782-.725-1.151-1.463-1.151-2.18 0-.719.369-1.456 1.151-2.181.783-.726 1.944-1.403 3.42-1.982 2.948-1.156 7.055-1.882 11.617-1.882 4.562 0 8.669.726 11.617 1.882 1.476.579 2.636 1.256 3.42 1.981.782.726 1.15 1.463 1.15 2.181Z"
      />
      <path
        fill="#D53439"
        d="M15.524 46.126V33.905c-.827-.222-1.653-.447-2.477-.677v12.898c-3.233 1.597-1.239 6.362-1.239 8.874h4.955c0-2.512 1.995-7.277-1.239-8.874Z"
      />
      <path
        fill="#302F2F"
        d="M72.126 34.519C72.126 33.329 42.38 25 40 25c-2.38 0-32.126 8.33-32.126 9.519 0 .744 8.843 3.816 15.468 6.012v7.077c4.76-4.76 16.658-4.76 16.658-4.76s11.899 0 16.658 4.76V40.53c6.625-2.196 15.468-5.268 15.468-6.012Z"
      />
    </g>
  ),
});

export const FlexibleTermTemplateIcon = createIcon({
  displayName: 'FlexibleTermTemplateIcon',
  viewBox: '0 0 80 80',
  path: (
    <g>
      <path
        fill="#EBBC70"
        d="M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40Z"
      />
      <path
        fill="#BA262B"
        d="M63.273 28.364H16.727V24a4.364 4.364 0 0 1 4.364-4.363H58.91A4.363 4.363 0 0 1 63.273 24v4.364Z"
      />
      <path
        fill="#D53439"
        d="M38.147 19.637H21.091A4.364 4.364 0 0 0 16.727 24v4.364H29.42l8.727-8.727Z"
      />
      <path
        fill="#FDFDFD"
        d="M63.273 58.909a4.363 4.363 0 0 1-4.364 4.364H21.091a4.364 4.364 0 0 1-4.364-4.364V28.363h46.546V58.91Z"
      />
      <path fill="#68A4CA" d="M32 34.182h7.273v6.545H32v-6.545Z" />
      <path
        fill="#E2EEF3"
        d="M32 42.182h7.273v6.545H32v-6.545Zm8.727 0H48v6.545h-7.273v-6.545Zm-18.182-8h8v6.545h-8v-6.545Zm18.182 0H48v6.545h-7.273v-6.545Z"
      />
      <path fill="#68A4CA" d="M40.727 50.182H48v7.273h-7.273v-7.273Z" />
      <path
        fill="#E2EEF3"
        d="M49.455 42.182h7.272v6.545h-7.272v-6.545Zm0-8h7.272v6.545h-7.272v-6.545Zm0 16h7.272v7.273h-7.272v-7.273Zm-26.91-8h8v6.545h-8v-6.545Zm0 8h8v7.273h-8v-7.273Zm9.455 0h7.273v7.273H32v-7.273Z"
      />
      <path
        fill="#4E4D4D"
        d="M26.909 23.273c0 1.2-.982 2.182-2.182 2.182s-2.182-.982-2.182-2.182v-4.364c0-1.2.982-2.182 2.182-2.182s2.182.982 2.182 2.182v4.364Zm30.546 0c0 1.2-.982 2.182-2.182 2.182s-2.182-.982-2.182-2.182v-4.364c0-1.2.982-2.182 2.182-2.182s2.181.982 2.181 2.182v4.364Zm-15.273 0c0 1.2-.982 2.182-2.182 2.182s-2.182-.982-2.182-2.182v-4.364c0-1.2.982-2.182 2.182-2.182s2.182.982 2.182 2.182v4.364Z"
      />
    </g>
  ),
});

export const AffordableTemplateIcon = createIcon({
  displayName: 'AffordableTemplateIcon',
  viewBox: '0 0 80 80',
  path: (
    <g>
      <path
        fill="#E3787B"
        d="M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40Z"
      />
      <path
        fill="#EBC9AB"
        d="M61.213 42.39a2.122 2.122 0 0 0-2.664-.886l-13.197 5.742c-.57.242-1.17.41-1.782.5l-12.028 1.771 7.736-3.91a2.456 2.456 0 0 0-.286-4.484c-.6-.22-1.909 2.58-2.492 2.839l-8 5.555c-.776.356-1.448 2.313-2 2.964-.551.652 1.501-2.539 1.278-1.715l2.244 2.265 1.078.131c-.15-4.362 1.999-.351 2.514-.68.515-.33 1.282 2.52 1.886 2.43l6-1.75c1.007-.148 3.164 2.294 4.023 1.75l14.99-9.66a2.124 2.124 0 0 0 .7-2.861Z"
      />
      <path fill="#FDFDFD" d="M28.342 31.089v18.366h29.09V31.089l-14.545-10.91-14.545 10.91Z" />
      <path
        fill="#981F23"
        d="M57.433 31.089h2.225a.727.727 0 0 0 .444-1.304l-16.78-12.907a.727.727 0 0 0-.876-.008L25.022 29.777a.727.727 0 0 0 .433 1.312h2.888L42.888 20.18 57.433 31.09Z"
      />
      <path fill="#46351D" d="M39 40h8v12h-8z" />
      <path
        fill="#68A4CA"
        d="M33.433 31.273h5.818v5.818h-5.818v-5.818Zm13.09 0h5.819v5.818h-5.819v-5.818Z"
      />
      <path
        fill="#EBC9AB"
        d="M63.12 46.727a2.122 2.122 0 0 0-2.506-1.266L46.72 49.22c-.6.155-1.216.235-1.836.235H32.727l8.224-2.742a2.455 2.455 0 0 0-1.463-4.685l-12.87 3.754a5.822 5.822 0 0 0-3.706 3.265l-4.287 9.862h13.162a4.351 4.351 0 0 1 3.237-1.454h7.796a7.264 7.264 0 0 0 2.954-.627l16.237-7.373a2.124 2.124 0 0 0 1.11-2.728Z"
      />
      <path
        fill="#FDFDFD"
        d="M16.727 59.636a.727.727 0 0 1 .727-.727h15.368a.727.727 0 0 1 .605 1.131l-1.94 2.91a.725.725 0 0 1-.604.323H17.454a.727.727 0 0 1-.727-.728v-2.909Z"
      />
      <path fill="#E7AF55" d="M29.818 61.818a1.09 1.09 0 1 0 0-2.182 1.09 1.09 0 0 0 0 2.182Z" />
      <path
        fill="#FCDBBD"
        d="M40.699 41.991c-.4-.09-.817-.077-1.211.037l-12.87 3.754a5.822 5.822 0 0 0-3.706 3.265l-4.287 9.862h5.156S23.782 57.12 24 56c.5-2.572 1.253-4.048 3-6 1.5-1.676 4-2.998 4-2.998l9.699-5.01Z"
      />
    </g>
  ),
});

export const MilitaryTemplateIcon = createIcon({
  displayName: 'MilitaryTemplateIcon',
  viewBox: '0 0 80 80',
  path: (
    <g>
      <path
        fill="#A58DA5"
        d="M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40Z"
      />
      <path fill="#4E4D4D" d="M39.703 56.273c.016-.016.015-.029 0-.04-.016.012-.017.024 0 .04Z" />
      <path
        fill="#4E4D4D"
        d="M58.98 49.847c-2.57-3.855-19.277-3.855-19.277-3.855s-16.707 0-19.277 3.855c3.851 7.354 18.799 6.036 19.277 6.386.478-.35 15.425.968 19.277-6.386Z"
      />
      <path
        fill="#406444"
        d="M39.703 23C28.404 23 14 31.855 14 39.566c0 6.426 6.426 6.426 6.426 6.426v-1.285c.758-.048 3.855-6.426 19.277-6.426 15.421 0 18.518 6.378 19.276 6.426v1.285s6.426 0 6.426-6.426C65.405 31.856 51 23 39.702 23Z"
      />
      <path
        fill="#D6901F"
        d="M39.703 38.281c-14.137 0-19.277 5.14-19.277 6.426v5.14c3.855-3.855 19.277-3.855 19.277-3.855s15.421 0 19.277 3.855v-5.14c0-1.285-5.14-6.426-19.277-6.426Z"
      />
      <path
        fill="#302F2F"
        d="M39.703 45.992s-16.707 0-19.277 3.855c3.851 7.354 18.799 6.036 19.277 6.386.478-.348 15.425.968 19.277-6.386-2.57-3.855-19.277-3.855-19.277-3.855Z"
      />
      <path
        fill="#4E4D4D"
        d="M20.426 49.847c3.851 7.354 18.799 6.036 19.277 6.386V45.992s-16.707 0-19.277 3.855Z"
      />
      <path
        fill="#E7AF55"
        d="M20.426 44.707v5.14c3.855-3.855 19.277-3.855 19.277-3.855V38.28c-14.137 0-19.277 5.14-19.277 6.426Z"
      />
      <path
        fill="#507C56"
        d="M14 39.566c0 6.426 6.426 6.426 6.426 6.426v-1.285c.758-.048 3.855-6.426 19.277-6.426V23C29 23 14 31.855 14 39.566Z"
      />
      <path
        fill="#D6901F"
        d="M39.447 26.146a.261.261 0 0 1 .47 0l1.39 2.818a.262.262 0 0 0 .198.143l3.11.452a.262.262 0 0 1 .144.447l-2.25 2.193a.262.262 0 0 0-.075.232l.531 3.097a.262.262 0 0 1-.38.276l-2.781-1.462a.261.261 0 0 0-.244 0l-2.781 1.462a.262.262 0 0 1-.38-.276l.53-3.097a.26.26 0 0 0-.075-.232l-2.25-2.193a.262.262 0 0 1 .145-.447l3.11-.452a.261.261 0 0 0 .197-.143l1.391-2.818Z"
      />
      <path
        fill="#E7AF55"
        d="M36.302 35.59a.25.25 0 0 0 .36.27l3.02-1.563s.013-2.754 0-4.434c-.003-.39 0-1.031 0-1.207 0-.156.019-1.032 0-1.07V26a.262.262 0 0 0-.235.146l-1.39 2.818a.26.26 0 0 1-.198.143l-3.11.452a.26.26 0 0 0-.145.447l2.25 2.193c.062.06.09.147.076.232l-.628 3.16Z"
      />
    </g>
  ),
});

export const ConventionalTemplateIcon = createIcon({
  displayName: 'ConventionalTemplateIcon',
  viewBox: '0 0 80 80',
  path: (
    <g>
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#3878A0"
      />
      <path d="M19.6362 19.9092H42.909V60.6365H19.6362V19.9092Z" fill="#EBBC70" />
      <path d="M42.9092 19.9092H60.3637V51.9092H42.9092V19.9092Z" fill="#E07E4A" />
      <path
        d="M16.7275 17H63.273L60.3639 19.9091H19.6366L16.7275 17ZM16.7275 63.5455H42.9094V60.6364H19.6366L16.7275 63.5455Z"
        fill="#FDFDFD"
      />
      <path d="M42.9092 51.9092H60.3637V63.5455H42.9092V51.9092Z" fill="#D4D3D3" />
      <path
        d="M57.4547 51.909H45.8184V42.4544C45.8184 40.9113 46.4313 39.4315 47.5225 38.3403C48.6136 37.2492 50.0935 36.6362 51.6365 36.6362C53.1796 36.6362 54.6595 37.2492 55.7506 38.3403C56.8417 39.4315 57.4547 40.9113 57.4547 42.4544V51.909Z"
        fill="#FDFDFD"
      />
      <path
        d="M48 42.4545C48 41.4901 48.3831 40.5651 49.0651 39.8832C49.747 39.2012 50.6719 38.8181 51.6364 38.8181C52.6008 38.8181 53.5257 39.2012 54.2077 39.8832C54.8896 40.5651 55.2727 41.4901 55.2727 42.4545H48Z"
        fill="#3878A0"
      />
      <path d="M48 43.9092H55.2727V51.9092H48V43.9092Z" fill="#E0E0E0" />
      <path
        d="M42.9092 60.6365H60.3637V62.091H42.9092V60.6365ZM42.9092 57.7274H60.3637V59.1819H42.9092V57.7274ZM42.9092 54.8183H60.3637V56.2728H42.9092V54.8183ZM42.9092 51.9092H60.3637V53.3637H42.9092V51.9092Z"
        fill="#F5F5F5"
      />
      <path
        d="M51.6364 31.5454C49.6313 31.5454 48 29.9142 48 27.9091C48 25.904 49.6313 24.2727 51.6364 24.2727C53.6415 24.2727 55.2727 25.904 55.2727 27.9091C55.2727 29.9142 53.6415 31.5454 51.6364 31.5454Z"
        fill="#3878A0"
      />
      <path
        d="M51.6363 24.2727C53.6414 24.2727 55.2727 25.9039 55.2727 27.909C55.2727 29.9141 53.6414 31.5454 51.6363 31.5454C49.6312 31.5454 48 29.9141 48 27.909C48 25.9039 49.6312 24.2727 51.6363 24.2727ZM51.6363 22.8181C50.2861 22.8181 48.9912 23.3545 48.0365 24.3092C47.0818 25.2639 46.5454 26.5588 46.5454 27.909C46.5454 29.2592 47.0818 30.5541 48.0365 31.5088C48.9912 32.4636 50.2861 32.9999 51.6363 32.9999C52.9865 32.9999 54.2814 32.4636 55.2361 31.5088C56.1909 30.5541 56.7272 29.2592 56.7272 27.909C56.7272 26.5588 56.1909 25.2639 55.2361 24.3092C54.2814 23.3545 52.9865 22.8181 51.6363 22.8181Z"
        fill="#FDFDFD"
      />
      <path
        d="M29.8181 57H22.5454V46.091C22.5454 45.1265 22.9285 44.2016 23.6105 43.5197C24.2924 42.8377 25.2174 42.4546 26.1818 42.4546C27.1462 42.4546 28.0711 42.8377 28.7531 43.5197C29.435 44.2016 29.8181 45.1265 29.8181 46.091V57Z"
        fill="#3878A0"
      />
      <path
        d="M22.5454 51.9091H29.8181V57H22.5454V51.9091ZM40 57H32.7272V46.091C32.7272 45.1265 33.1103 44.2016 33.7923 43.5197C34.4742 42.8377 35.3992 42.4546 36.3636 42.4546C37.328 42.4546 38.2529 42.8377 38.9349 43.5197C39.6168 44.2016 40 45.1265 40 46.091V57Z"
        fill="#3878A0"
      />
      <path
        d="M32.7275 51.909H40.0003V56.9999H32.7275V51.909ZM40.0003 37.3636H32.7275V26.4545C32.7275 25.4901 33.1107 24.5651 33.7926 23.8832C34.4746 23.2012 35.3995 22.8181 36.3639 22.8181C37.3283 22.8181 38.2532 23.2012 38.9352 23.8832C39.6172 24.5651 40.0003 25.4901 40.0003 26.4545V37.3636Z"
        fill="#3878A0"
      />
      <path d="M32.7275 32.2727H40.0003V37.3636H32.7275V32.2727Z" fill="#3878A0" />
      <path
        d="M40.0003 27.4363V26.4545C40.0003 25.4901 39.6172 24.5651 38.9352 23.8832C38.2532 23.2012 37.3283 22.8181 36.3639 22.8181C35.3995 22.8181 34.4746 23.2012 33.7926 23.8832C33.1107 24.5651 32.7275 25.4901 32.7275 26.4545V34.709L40.0003 27.4363Z"
        fill="#68A4CA"
      />
      <path
        d="M35.1636 32.2727H32.7272V34.7091L35.1636 32.2727ZM29.8181 47.0727V46.0909C29.8181 45.1265 29.435 44.2015 28.7531 43.5196C28.0711 42.8376 27.1462 42.4545 26.1818 42.4545C25.2174 42.4545 24.2924 42.8376 23.6105 43.5196C22.9285 44.2015 22.5454 45.1265 22.5454 46.0909V54.3454L29.8181 47.0727Z"
        fill="#68A4CA"
      />
      <path
        d="M24.9818 51.9091H22.5454V54.3455L24.9818 51.9091ZM40 47.0728V46.091C40 45.1265 39.6168 44.2016 38.9349 43.5197C38.2529 42.8377 37.328 42.4546 36.3636 42.4546C35.3992 42.4546 34.4742 42.8377 33.7923 43.5197C33.1103 44.2016 32.7272 45.1265 32.7272 46.091V54.3455L40 47.0728Z"
        fill="#68A4CA"
      />
      <path d="M35.1639 51.9092H32.7275V54.3455L35.1639 51.9092Z" fill="#68A4CA" />
      <path
        d="M32.7275 30.8181H40.0003V32.2727H32.7275V30.8181ZM22.5457 50.4545H29.8184V51.909H22.5457V50.4545ZM32.7275 50.4545H40.0003V51.909H32.7275V50.4545ZM16.7275 37.3636H42.9094V40.2727H19.6366L16.7275 37.3636Z"
        fill="#FDFDFD"
      />
      <path
        d="M29.8181 37.3636H22.5454V26.4545C22.5454 25.4901 22.9285 24.5651 23.6105 23.8832C24.2924 23.2012 25.2174 22.8181 26.1818 22.8181C27.1462 22.8181 28.0711 23.2012 28.7531 23.8832C29.435 24.5651 29.8181 25.4901 29.8181 26.4545V37.3636Z"
        fill="#3878A0"
      />
      <path d="M22.5454 32.2727H29.8181V37.3636H22.5454V32.2727Z" fill="#3878A0" />
      <path
        d="M29.8181 27.4363V26.4545C29.8181 25.4901 29.435 24.5651 28.7531 23.8832C28.0711 23.2012 27.1462 22.8181 26.1818 22.8181C25.2174 22.8181 24.2924 23.2012 23.6105 23.8832C22.9285 24.5651 22.5454 25.4901 22.5454 26.4545V34.709L29.8181 27.4363Z"
        fill="#68A4CA"
      />
      <path
        d="M22.5454 30.8181H29.8181V32.2727H22.5454V30.8181ZM60.3636 63.5454H63.2727V47.5454C63.2727 47.1596 63.1194 46.7896 62.8467 46.5169C62.5739 46.2441 62.2039 46.0908 61.8181 46.0908C61.4324 46.0908 61.0624 46.2441 60.7896 46.5169C60.5168 46.7896 60.3636 47.1596 60.3636 47.5454V63.5454Z"
        fill="#FDFDFD"
      />
    </g>
  ),
});

export const AmexIcon = createIcon({
  displayName: 'Amex Icon',
  viewBox: '0 0 64 40',
  path: (
    <path
      d="M36.7,27.1L36,26.2v0.9h-2.4v-1.5c0,0-0.3,0.2-1,0.2h-0.8v1.3h-3.6l-0.6-0.9l-0.6,0.9H21v-5.7h6l0.6,0.8 l0.7-0.8h21.7V2H14v15.2l1.3-3.1h2.3l0.8,1.8V14h2.9l0.5,1.3l0.4-1.3h13v0.6c0,0,0.7-0.6,1.8-0.6l4.2,0l0.8,1.7V14h2.4l0.7,1v-1h2.4 v5.7h-2.4l-0.6-1v1h-3.6l-0.4-0.9h-1l-0.4,0.9h-2.4c-1,0-1.6-0.6-1.6-0.6v0.6h-3.6l-0.7-0.9v0.9H17.3L17,18.8h-1l-0.4,0.9H14L14,38 h35.9V26.7c0,0-0.6,0.4-1.2,0.4H36.7z M17.5,18.1l0.3,0.8H19l-1.8-4.2h-1.4v0L14,19h1.2l0.3-0.8H17.5z M16.5,15.7l0.6,1.5h-1.2 L16.5,15.7z M24.4,19v-4.2h-1.7l-1,2.7l-1-2.7l-1.7,0V19h1.1v-3.1l1.1,3.1h0.9l1.1-3.1V19H24.4z M28.6,15.7v-0.9h-3.4V19l3.4,0V18 h-2.4v-0.8h2.3v-0.9h-2.3v-0.7H28.6z M33,16.1c0-0.9-0.7-1.4-1.5-1.4h-2.3v0V19h1.1v-1.5h0.4L32,19h1.3l-1.4-1.6 C32.4,17.3,33,16.9,33,16.1z M31.5,16.6h-1.2v-0.9h1.2c0.3,0,0.5,0.2,0.5,0.4C32,16.4,31.7,16.6,31.5,16.6z M33.4,14.7V19h1.1v-4.2 H33.4z M35,16.9c0,1.2,0.7,2.1,1.8,2.1h0.2l0.4-0.9h-0.3c-0.7,0-1.1-0.3-1.1-1.2c0-0.7,0.4-1.1,1-1.1h1.2v-1h-1.2 C35.7,14.7,35,15.6,35,16.9z M38.7,19l0.3-0.8H41l0.3,0.8h1.2l-1.8-4.2h-1.4v0L37.6,19H38.7z M40,15.7l0.6,1.5h-1.2L40,15.7z M45.5,19h1.3v-4.2h-1.1v2.7L44,14.7h-1.3V19h1.1v-2.7L45.5,19z M25.1,23.1v-0.9h-3.4v4.2l3.4,0v-0.9h-2.4v-0.8h2.3v-0.9h-2.3v-0.7 H25.1z M42,23.1v-0.9h-3.4v4.2l3.4,0v-0.9h-2.4v-0.8h2.3v-0.9h-2.3v-0.7H42z M28.6,22.1l-1,1.3l-1-1.3h-1.3l1.7,2.1l-1.7,2.1l1.3,0 l1-1.3l1,1.3h1.3l-1.7-2.1l1.7-2.1H28.6z M30,22.1L30,22.1l0,4.2h1.1V25h1.1c0.9,0,1.7-0.5,1.7-1.5c0-0.8-0.6-1.4-1.5-1.4H30z M32.8,23.6c0,0.3-0.2,0.5-0.5,0.5h-1.2v-1v0h1.2C32.6,23.1,32.8,23.3,32.8,23.6z M35.4,26.4v-1.5h0.4l1.3,1.5h1.3L37,24.8 c0.6,0,1.2-0.5,1.2-1.3c0-0.9-0.7-1.4-1.5-1.4h-2.3l0,0v4.2H35.4z M35.4,23.1h1.2c0.3,0,0.5,0.2,0.5,0.4c0,0.3-0.3,0.4-0.5,0.4h-1.2 V23.1z M44.6,25.4h-2.1v0.9h2.2c0.9,0,1.4-0.6,1.4-1.3c0-0.7-0.4-1.2-1.3-1.2h-1c-0.3,0-0.4-0.2-0.4-0.4c0-0.2,0.1-0.3,0.4-0.3h1.8 l0.4-1H44c-1.2,0-1.7,0.7-1.7,1.3c0,0.8,0.5,1.3,1.3,1.3h1c0.3,0,0.4,0.2,0.4,0.4C45.1,25.3,44.9,25.4,44.6,25.4z M47.7,23.1h1.8 l0.4-1h-2.1c-1.2,0-1.7,0.7-1.7,1.3c0,0.8,0.5,1.3,1.3,1.3h1c0.3,0,0.4,0.2,0.4,0.4c0,0.2-0.1,0.4-0.4,0.4h-2.1v0.9h2.2 c0.9,0,1.4-0.6,1.4-1.3c0-0.7-0.4-1.2-1.3-1.2h-1c-0.3,0-0.4-0.2-0.4-0.4C47.3,23.3,47.4,23.1,47.7,23.1z"
      fill="rgb(1, 111, 208)"
    />
  ),
});

export const DiscoverIcon = createIcon({
  displayName: 'Discover Icon',
  viewBox: '0 0 64 40',
  path: (
    <>
      <path fill="#F58220" d="M63.6 22.3S46.2 34.5 14.4 40h49.2V22.3z" />
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1="36.107"
        y1="621.356"
        x2="32.696"
        y2="626.697"
        gradientTransform="matrix(1 0 0 -1 0 642)"
      >
        <stop offset="0" stopColor="#f9a020" />
        <stop offset="0.204" stopColor="#f99d20" />
        <stop offset="0.435" stopColor="#f79320" />
        <stop offset="0.62" stopColor="#f68820" />
        <stop offset="0.797" stopColor="#f57e20" />
        <stop offset="1" stopColor="#f47521" />
      </linearGradient>
      <path
        fill="url(#a)"
        d="M38.5 16.7c0 2.7-2.2 4.9-4.9 4.9s-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9c2.6 0 4.9 2.2 4.9 4.9z"
      />
      <path d="M52.7 19.8h-3.3v-2.5h3.2v-1.6h-3.2v-2h3.3v-1.6h-5.1v9.3h5.1v-1.6zm2.9-2.2h.3l2.5 3.7h2.2l-2.9-3.9c1.4-.3 2.1-1.2 2.1-2.6 0-1.7-1.2-2.7-3.3-2.7h-2.7v9.3h1.8v-3.8zm.1-4.1h.6c1.1 0 1.7.5 1.7 1.4 0 .9-.6 1.4-1.8 1.4h-.5v-2.8zM8.9 20.3c1-.9 1.7-2.2 1.7-3.6 0-2.7-2-4.6-5-4.6H2.9v9.3h2.6C7 21.3 8 21 8.9 20.3zm-4.2-.5v-6.1h.5c1.2 0 1.9.2 2.5.8.6.6 1 1.4 1 2.3 0 .9-.4 1.8-1 2.3-.6.5-1.3.7-2.5.7h-.5zm38.1 1.8l4-9.5h-2l-2.5 6.2-2.5-6.2h-2l3.9 9.5h1.1zm-29.6-9.5h-1.8v9.3h1.8v-9.3zM0 0v40h64V0H0zm63.5 39.5H.5V.5h63v39zm-37.7-18c.8 0 1.4-.2 2.3-.5v-2.1c-.7.7-1.4 1-2.2 1-1.8 0-3.1-1.3-3.1-3.2 0-1.8 1.3-3.2 3-3.2.9 0 1.5.3 2.3 1v-2.1c-.8-.4-1.4-.6-2.2-.6-2.7 0-4.9 2.2-4.9 4.9-.1 2.7 2 4.8 4.8 4.8zM17 19.9c-.9 0-1.5-.4-2-1.2l-1.2 1.1c.8 1.2 1.8 1.8 3.2 1.8 1.9 0 3.2-1.3 3.2-3 0-1.5-.6-2.2-2.7-2.9-1.1-.4-1.4-.7-1.4-1.2 0-.6.6-1 1.3-1 .5 0 1 .2 1.5.8L20 13c-.8-.7-1.7-1-2.7-1-1.6 0-2.9 1.1-2.9 2.7 0 1.3.6 1.9 2.3 2.5.7.3 1.1.4 1.3.5.4.2.5.6.5 1-.1.7-.6 1.2-1.5 1.2z" />
    </>
  ),
});

export const MasterCardIcon = createIcon({
  displayName: 'MasterCard Icon',
  viewBox: '0 0 64 40',
  path: (
    <>
      <path
        fill="#F7A000"
        d="M39.6,4.4c-2.9,0-5.5,1-7.6,2.6c2.9,2.3,4.7,5.8,4.7,9.7s-1.8,7.4-4.7,9.7c2.1,1.7,4.8,2.6,7.6,2.6 c6.8,0,12.4-5.5,12.4-12.4S46.5,4.4,39.6,4.4z"
      />
      <path
        fill="#EA0C08"
        d="M27.3,16.8c0-3.9,1.8-7.4,4.7-9.7c-2.1-1.7-4.8-2.6-7.6-2.6C17.5,4.4,12,10,12,16.8s5.5,12.4,12.4,12.4 c2.9,0,5.5-1,7.6-2.6C29.1,24.2,27.3,20.7,27.3,16.8z"
      />
      <path
        fill="#FF6100"
        d="M36.7,16.8c0-3.9-1.8-7.4-4.7-9.7c-2.9,2.3-4.7,5.8-4.7,9.7s1.8,7.4,4.7,9.7C34.9,24.2,36.7,20.7,36.7,16.8z"
      />
      <path d="M18.6,32.3c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8v2h-0.5v-1.9c0-0.3-0.1-0.6-0.2-0.8c-0.2-0.2-0.4-0.3-0.7-0.3 c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.2,0.4-0.2,0.8v1.9h-0.5v-1.9c0-0.3-0.1-0.6-0.2-0.8c-0.2-0.2-0.4-0.3-0.7-0.3s-0.5,0.1-0.7,0.3 c-0.2,0.2-0.2,0.4-0.2,0.8v1.9H14v-3.3h0.5v0.5c0.1-0.2,0.3-0.3,0.4-0.4c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.5,0.1,0.7,0.2 c0.2,0.1,0.4,0.3,0.5,0.5c0.1-0.2,0.3-0.4,0.5-0.5s0.4-0.2,0.7-0.2C18.2,32.1,18.4,32.2,18.6,32.3z" />
      <path d="M22.3,32.3c0.2,0.1,0.4,0.3,0.5,0.5v-0.7h0.6v3.3h-0.6v-0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.7,0.2 c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.4-0.6-0.6c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.6 c0.2-0.1,0.5-0.2,0.8-0.2C21.9,32.1,22.1,32.2,22.3,32.3z M21.1,32.8c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.7 c0,0.2,0,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.4,0.4s0.4,0.2,0.6,0.2c0.2,0,0.4,0,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2,0-0.5-0.2-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2C21.5,32.6,21.3,32.7,21.1,32.8z" />
      <path d="M26.4,32.4c0.2,0.2,0.3,0.4,0.3,0.8h-0.6c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0-0.5,0.1 s-0.2,0.2-0.2,0.4c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.3,0.1,0.5,0.1c0.2,0.1,0.4,0.1,0.6,0.2s0.3,0.1,0.4,0.3 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.4,0.1-0.7,0.1c-0.4,0-0.7-0.1-0.9-0.3 c-0.2-0.2-0.3-0.4-0.4-0.8h0.6c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4,0,0.5-0.1c0.1-0.1,0.2-0.2,0.2-0.4 c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.3-0.1-0.4-0.3 c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0-0.3,0.2-0.5c0.1-0.2,0.2-0.3,0.4-0.4s0.4-0.1,0.7-0.1C25.9,32.1,26.2,32.2,26.4,32.4z" />
      <path d="M29.2,35.1v0.4h-0.6c-0.3,0-0.5-0.1-0.6-0.2s-0.2-0.4-0.2-0.6v-2h-0.4v-0.4h0.4v-0.8h0.6v0.8h0.9v0.4h-0.9v2 c0,0.2,0,0.3,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1H29.2z" />
      <path d="M32.9,34h-2.6c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.4,0,0.6-0.2c0.2-0.1,0.3-0.2,0.3-0.4h0.6 c-0.1,0.3-0.3,0.5-0.5,0.7c-0.3,0.2-0.6,0.3-1,0.3c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.3-0.6-0.6c-0.1-0.3-0.2-0.6-0.2-0.9 s0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.6c0.2-0.1,0.5-0.2,0.9-0.2c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.3,0.6,0.6 c0.1,0.2,0.2,0.5,0.2,0.8C33,33.8,32.9,33.9,32.9,34z M32.4,33.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.4-0.4 c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.8L32.4,33.6L32.4,33.6z" />
      <path d="M35.3,32.1v0.6h-0.1c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.1-0.2,0.4-0.2,0.8v1.8h-0.5v-3.3h0.5v0.6C34.5,32.3,34.8,32.1,35.3,32.1 z" />
      <path d="M38.5,32.4c0.2,0.2,0.4,0.5,0.5,0.8h-0.6c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3,0-0.6,0.1-0.8,0.3 c-0.2,0.2-0.3,0.5-0.3,0.9c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.4,0.3,0.8,0.3c0.2,0,0.4,0,0.6-0.2c0.2-0.1,0.3-0.3,0.3-0.5H39 c-0.1,0.3-0.3,0.6-0.5,0.8c-0.3,0.2-0.6,0.3-1,0.3c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.3-0.6-0.6c-0.1-0.3-0.2-0.6-0.2-0.9 c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.6c0.2-0.1,0.5-0.2,0.8-0.2C37.9,32.1,38.2,32.2,38.5,32.4z" />
      <path d="M41.9,32.3c0.2,0.1,0.4,0.3,0.5,0.5v-0.7H43v3.3h-0.6v-0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.7,0.2 c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.4-0.6-0.6c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.6 c0.2-0.1,0.5-0.2,0.8-0.2C41.5,32.1,41.7,32.2,41.9,32.3z M40.7,32.8c-0.2,0.1-0.3,0.2-0.4,0.4s-0.2,0.4-0.2,0.7 c0,0.2,0,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.2,0.6,0.2s0.4,0,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2,0-0.5-0.2-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2C41.1,32.6,40.9,32.7,40.7,32.8z" />
      <path d="M45.6,32.1v0.6h-0.1c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.1-0.2,0.4-0.2,0.8v1.8H44v-3.3h0.5v0.6C44.7,32.3,45.1,32.1,45.6,32.1z" />
      <path d="M48.4,32.3c0.2,0.1,0.4,0.3,0.5,0.5V31h0.6v4.5h-0.6v-0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.7,0.2 c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.4-0.6-0.6c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.6 c0.2-0.1,0.5-0.2,0.8-0.2C48,32.1,48.2,32.2,48.4,32.3z M47.2,32.8c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.7 c0,0.2,0,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.4,0.4s0.4,0.2,0.6,0.2c0.2,0,0.4,0,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2,0-0.5-0.2-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2C47.6,32.6,47.4,32.7,47.2,32.8z" />
      <path d="M50.5,35c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0s-0.1,0-0.1,0 c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0C50.4,34.9,50.5,35,50.5,35z M50.5,35.4 C50.5,35.4,50.6,35.4,50.5,35.4c0.1-0.1,0.1-0.2,0.1-0.2s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0C50.4,35.5,50.5,35.5,50.5,35.4z M50.5,35.2 C50.5,35.2,50.4,35.2,50.5,35.2l0,0.2h-0.1l-0.1-0.2h0v0.2h0V35h0.1c0,0,0.1,0,0.1,0C50.5,35.1,50.5,35.1,50.5,35.2 C50.5,35.2,50.5,35.2,50.5,35.2z M50.3,35.2L50.3,35.2c0.1,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0,0,0-0.1-0.1-0.1h-0.1V35.2z" />
    </>
  ),
});

export const VisaIcon = createIcon({
  displayName: 'Visa Icon',
  viewBox: '0 0 64 40',
  path: (
    <>
      <path
        fill="#FFF"
        d="M63.7,37.6c0,1.3-1.1,2.4-2.4,2.4H2.6c-1.3,0-2.4-1.1-2.4-2.4V2.4C0.3,1.1,1.3,0,2.6,0h58.7c1.3,0,2.4,1.1,2.4,2.4V37.6"
      />
      <path
        fill="#2A2A6C"
        d="M24.4,11.6l-7.1,16.8h-4.6L9.3,15c-0.2-0.8-0.4-1.1-1-1.5c-1-0.6-2.8-1.1-4.3-1.4L4,11.6h7.4c0.9,0,1.8,0.6,2,1.7l1.8,9.7l4.5-11.5H24.4 M42.4,22.9c0-4.4-6.1-4.7-6.1-6.7c0-0.6,0.6-1.2,1.8-1.4c0.6-0.1,2.3-0.1,4.3,0.8l0.8-3.6c-1-0.4-2.4-0.7-4.1-0.7c-4.3,0-7.3,2.3-7.4,5.6c0,2.4,2.2,3.8,3.8,4.6c1.7,0.8,2.3,1.4,2.3,2.1c0,1.1-1.4,1.6-2.6,1.6c-2.2,0-3.5-0.6-4.5-1.1L30,27.8c1,0.5,2.9,0.9,4.8,0.9C39.4,28.7,42.4,26.4,42.4,22.9 M53.8,28.4h4l-3.5-16.8h-3.7c-0.8,0-1.5,0.5-1.9,1.2l-6.5,15.6h4.6l0.9-2.5h5.6L53.8,28.4z M48.9,22.5l2.3-6.3l1.3,6.3H48.9z M30.6,11.6L27,28.4h-4.4l3.6-16.8H30.6z"
      />
    </>
  ),
});

export const LockIcon = createIcon({
  displayName: 'Lock Icon',
  viewBox: '0 0 10 12',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.59922 4.5375V3.4875C8.59922 1.5375 6.96498 0 4.98054 0C2.99611 0 1.36187 1.5375 1.36187 3.4875V4.575H0V12H10V4.5375H8.59922ZM2.56805 3.4875C2.56805 2.175 3.65755 1.125 4.98051 1.125C6.30346 1.125 7.39296 2.175 7.39296 3.45V4.5375H2.56805V3.4875ZM8.7938 10.875H1.16734V5.66251H8.7938V10.875Z"
      fill="#252B30"
    />
  ),
});

export const ArrowSplitIcon = createIcon({
  displayName: 'Arrow Split Icon',
  viewBox: '0 0 16 16',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6 10.6431L13.45 11.4876H8.9C7.9 11.4876 7.15 10.6928 7.1 9.74902C7.1 9.69935 7.15 8.8549 6.85 8.35817C7.2 8.01046 7.1 7.06667 7.1 6.96732C7.1 5.97386 7.9 5.17909 8.85 5.17909H13.5L12.6 6.0732L13.5 6.96732L16 4.48366L13.5 2L12.6 2.89412L13.5 3.78824H8.9C7.1 3.78824 5.7 5.17908 5.7 6.96732C5.6 7.36471 5.05 7.61307 4.65 7.61307H0V9.10327H4.65C5 9.10327 5.55 9.30196 5.7 9.74902C5.7 11.5373 7.1 12.9281 8.9 12.9281H13.45L12.6 13.7725L13.5 14.6667L16 12.183L13.5 9.74902L12.6 10.6431Z"
      fill="#1578C9"
    />
  ),
});

export const GlobeIcon = createIcon({
  displayName: 'GlobeIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
      <path d="M2 12h20" />
    </svg>
  ),
});

/** Sparkle / magic-wand style mark commonly used for AI-assisted actions */
export const AiSparklesIcon = createIcon({
  displayName: 'AiSparklesIcon',
  viewBox: '0 0 24 24',
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
      <path d="M5 3v4" />
      <path d="M19 17v4" />
      <path d="M3 5h4" />
      <path d="M17 19h4" />
    </g>
  ),
});
